import _ from 'lodash';

export const regions = [
	{
		display: 'Los Angeles',
		value: 'losAngeles',
	},
	{
		display: 'North',
		value: 'north',
	},
	{
		display: 'Central',
		value: 'central',
	},
	{
		display: 'San Diego',
		value: 'sanDiego',
	},
	{
		display: 'Inland Empire',
		value: 'inlandEmpire',
	},
];

export const valueToDisplay = (value) => {
	if (value === 'none') {
		return 'None';
	} else {
		return _.get(_.find(regions, { value }), 'display', 'Missing');
	}
};
